import type { RichMediaLayout } from '@atlaskit/adf-schema';

export const nonWrappedLayouts: RichMediaLayout[] = ['center', 'wide', 'full-width'];
